(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ag-camp-registration"] && !Shopify.designMode) return;
  try {
    /**
   * Inscripcion de varios hermanos en un solo pedido.
   *
   * Un jugador: lo maneja el tema como siempre.
   * Dos o mas: cortamos el submit en captura (los manejadores de Horizon
   * detienen la propagacion, asi que en burbuja llegariamos tarde) y montamos
   * una linea de pedido por jugador contra /cart/add.js.
   */
  (() => {
    const init = (root) => {
      if (root.dataset.agReady) return;
      root.dataset.agReady = 'true';

      const list = root.querySelector('[data-ag-players]');
      const addBtn = root.querySelector('[data-ag-add]');
      const hint = root.querySelector('[data-ag-hint]');
      const errorEl = root.querySelector('[data-ag-error]');
      const max = parseInt(root.dataset.maxPlayers, 10) || 1;
      const cartUrl = root.dataset.cartUrl || '/cart';
      // Todas las rutas del carrito con el prefijo del mercado (/de-ch/, /de-at/...).
      // Sin el, /cart/add.js crea el carrito en el mercado International y el
      // padre suizo acaba pagando en USD el mismo numero que en CHF.
      const base = (root.dataset.rootUrl || window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      const template = list.querySelector('[data-ag-player]').cloneNode(true);

      const players = () => list.querySelectorAll('[data-ag-player]');

      const renumber = () => {
        players().forEach((p, i) => {
          const label = p.querySelector('[data-ag-player-label]');
          if (label) label.textContent = label.textContent.replace(/\d+$/, '') .trim() + ' ' + (i + 1);
          const remove = p.querySelector('[data-ag-remove]');
          if (remove) remove.hidden = i === 0;
        });
        const full = players().length >= max;
        if (addBtn) addBtn.hidden = full;
        if (hint) hint.hidden = !full;
      };

      const addPlayer = () => {
        if (players().length >= max) return;
        const clone = template.cloneNode(true);
        const n = players().length + 1;

        clone.querySelectorAll('[data-ag-key]').forEach((el) => {
          // Solo el primer jugador viaja por el camino nativo del tema.
          el.removeAttribute('name');
          if (el.type === 'checkbox' || el.type === 'radio') el.checked = false;
          else el.value = '';
          const oldId = el.id;
          if (oldId) {
            const newId = oldId + '-p' + n + '-' + Date.now().toString(36);
            const label = clone.querySelector('label[for="' + oldId + '"]');
            el.id = newId;
            if (label) label.setAttribute('for', newId);
          }
        });
        // los input hidden de los checkbox tambien dejan de enviarse
        clone.querySelectorAll('input[type="hidden"][name^="properties"]').forEach((el) => el.remove());

        list.appendChild(clone);
        renumber();
        clone.querySelector('input, select, textarea')?.focus();
      };

      // El detalle medico solo se abre si la respuesta es "Yes".
      // OJO: aqui dentro Liquid no se procesa. Solo comentarios de JS: un
      // comentario de Liquid sale literal y rompe el script entero.
      const toggleMedical = (select) => {
        const wrap = select.closest('.ag-registration__grid');
        const detail = wrap && wrap.querySelector('[data-ag-medical-detail]');
        if (!detail) return;
        const abierto = select.value === detail.dataset.trigger;
        detail.hidden = !abierto;
        if (!abierto) {
          // sin vaciarlo, un "No" seguiria mandando lo que se escribio antes
          detail.querySelectorAll('textarea, input').forEach((f) => { f.value = ''; });
        }
      };

      root.addEventListener('change', (e) => {
        if (e.target.tagName !== 'SELECT') return;
        const wrap = e.target.closest('.ag-registration__grid');
        if (wrap && wrap.querySelector('[data-ag-medical-detail]')) toggleMedical(e.target);
      });

      root.addEventListener('click', (e) => {
        const target = e.target instanceof Element ? e.target : null;
        if (!target) return;
        if (target.closest('[data-ag-add]')) { e.preventDefault(); addPlayer(); }
        const rm = target.closest('[data-ag-remove]');
        if (rm) {
          e.preventDefault();
          if (players().length > 1) { rm.closest('[data-ag-player]').remove(); renumber(); }
        }
      });

      const readFields = (scope) => {
        const out = {};
        scope.querySelectorAll('[data-ag-key]').forEach((el) => {
          const key = el.dataset.agKey;
          if (el.type === 'checkbox') out[key] = el.checked ? 'Yes' : 'No';
          else if (el.value !== '') out[key] = el.value;
        });
        return out;
      };

      // El id del formulario nos lo da el propio atributo form= de los campos.
      const formId = root.querySelector('[data-ag-key][form]')?.getAttribute('form');
      const form = formId ? document.getElementById(formId) : null;
      if (!form) return;

      // En window y en captura: Horizon delega el submit en document (tambien en
      // captura), asi que un listener en el form llega tarde y su "anadir al
      // carrito" se lanza igual. Desde window cortamos antes que el.
      window.addEventListener('submit', async (e) => {
        if (e.target !== form) return;
        const current = players();
        // Antes se dejaba pasar al camino nativo cuando habia un solo jugador.
        // Eso hacia que con uno se abriera el cajon y con dos se fuera al
        // carrito. Ahora lo interceptamos siempre: misma ruta y mismo destino
        // sea cual sea el numero de hermanos.

        if (!form.checkValidity()) { form.reportValidity(); return; }

        e.preventDefault();
        e.stopImmediatePropagation();

        const variantId = form.querySelector('[name="id"]')?.value;
        if (!variantId) return;

        const shared = Object.assign({}, ...Array.from(
          root.querySelectorAll('[data-ag-shared]'), (el) => readFields(el)));
        const items = Array.from(current).map((p) => ({
          id: Number(variantId),
          quantity: 1,
          properties: Object.assign({}, readFields(p), shared),
        }));
        // Tasa de procesamiento: una por jugador, y entonces directo al checkout
        // La tasa no se anade aqui: despues se ajusta a los jugadores que haya
        // de verdad en el carrito (si el padre vuelve atras y reenvia, no se
        // duplica la tasa aunque ya hubiera una en el carrito).
        const feeVariant = Number(root.dataset.feeVariant) || 0;

        errorEl.hidden = true;
        try {
          const res = await fetch(base + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
          if (feeVariant) {
            const cart = await (await fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })).json();
            const players = cart.items
              .filter((i) => String(i.variant_id) === String(variantId))
              .reduce((n, i) => n + i.quantity, 0);
            const updates = {};
            updates[feeVariant] = players;
            await fetch(base + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates }),
            });
          }
          window.location.href = feeVariant ? base + 'checkout' : cartUrl;
        } catch (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
          errorEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      }, true); // captura: Horizon corta la propagacion

      renumber();
    };

    const boot = () => document.querySelectorAll('[data-ag-registration]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
